// src/components/Header.js
import React, { useState } from "react";
import "./Header.css";

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="header">
      {/* botão hambúrguer */}
      <div
        className={`menu-toggle ${open ? "open" : ""}`}
        onClick={() => setOpen(!open)}
        aria-label="Alternar menu"
      >
        <span />
      </div>

      <div className="header-container">
        <nav className={`nav-menu ${open ? "active" : ""}`}>
          <a href="#hero">Home</a>
          <a href="#sobre">Sobre Mim</a>
          <a href="#servicos">Consultoria</a>
          <a
            href="https://link.hotmart.com/SEU_PRODUTO"
            target="_blank"
            rel="noopener noreferrer"
          >
            Serviços
          </a>
          <a
            href="https://wa.me/5565981152009"
            target="_blank"
            rel="noopener noreferrer"
          >
            Contato
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
